export const goDoigitAddons = [
    { id: 1, name: 'Consumables Cover', showMembers: false, CoverType:"53634" },
    { id: 2, name: 'PED waiver', showMembers: false, CoverType:"48734" }
  ];
